module.exports = "<div class=\"main\">\r\n  <router-outlet></router-outlet>\r\n</div>\r\n\r\n"